import React, {Component} from 'react';
import IconButton from '@material-ui/core/IconButton';
import {withStyles} from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from "prop-types";

const styles = theme => ({});

const INITIAL_STATE = {
};

class FolderDocumentsRefresh extends Component {

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
    }

    render() {

        const {anchorEl} = this.state;

        return (
            <React.Fragment>
                <Tooltip title={"Refresh"}>
                    <IconButton
                        aria-label="Menu"
                        aria-owns={anchorEl ? 'simple-menu' : undefined}
                        aria-haspopup="true"
                        color = "secondary"
                        onClick = {() => this.props.unmountFolderDocumentsGet()}
                    >
                        <i className='material-icons md-36'>
                            refresh
                        </i>

                    </IconButton>
                </Tooltip>

            </React.Fragment>
        )
    }

}

FolderDocumentsRefresh.propTypes = {
    unmountFolderDocumentsGet: PropTypes.func.isRequired,
    isFetching: PropTypes.bool
};

export default withStyles(styles)(FolderDocumentsRefresh);